import React from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import { useMyHrUserRolesDataByContract } from "my-hr/hooks";
import {
  OcCard,
  OcFileViewerAndDownloaderBox,
  OcPageTransition,
} from "oc/components";
import { useOcCurrentUserState, useOcIsMobile, useOcProperty } from "oc/hooks";

export const MyHRUserGuidesPage = () => {
  const { t } = useTranslation();
  const isMobile = useOcIsMobile();
  const { contractCode } = useOcCurrentUserState();
  const { data: rolesData } = useMyHrUserRolesDataByContract({
    contract: contractCode,
  });

  const { data: myDocumentsMenuEnabled } = useOcProperty({
    resource: "myDocuments",
    key: "myDocumentsMenuEnabled",
    fetchPolicy: "network-only",
  });

  const myDocumentsEnabled = myDocumentsMenuEnabled === "false" ? false : true;

  const roles = {
    isMyNewsUser: false,
    isMyNewsEditor: false,
    isMyNewsAdmin: false,
    isMyHrExaminer: false,
    isMyHrAdmin: false,
    isMyLeaveUser: false,
    isMyLeaveAdmin: false,
    isMyLeaveExaminer: false,
    isMyLeaveViewer: false,
    isMyLeaveAssigner: false,
    isMyCafeteriaUser: false,
    isMyCafeteriaAdmin: false,
    isMyTimeUser: false,
    isMyTimeExaminer: false,
    isMyTimeAdmin: false,
    isMyDocumentsOperator: false,
    isMyTimesheetUser: false,
    isMyTimesheetExaminer: false,
    isMyTimesheetViewer: false,
    isMyTimesheetAdmin: false,
  };

  rolesData?.forEach((item) => {
    if (item?.product === "MyNews") {
      if (item?.role === "user") roles.isMyNewsUser = true;
      if (item?.role === "editor") roles.isMyNewsEditor = true;
      if (item?.role === "admin") roles.isMyNewsAdmin = true;
    } else if (item?.product === "MyHR") {
      if (item?.role === "examiner") roles.isMyHrExaminer = true;
      if (item?.role === "admin") roles.isMyHrAdmin = true;
    } else if (item?.product === "MyLeave") {
      if (item?.role === "user") roles.isMyLeaveUser = true;
      if (item?.role === "admin") roles.isMyLeaveAdmin = true;
      if (item?.role === "examiner") roles.isMyLeaveExaminer = true;
      if (item?.role === "viewer") roles.isMyLeaveViewer = true;
      if (item?.role === "assigner") roles.isMyLeaveAssigner = true;
    } else if (item?.product === "MyCafeteria") {
      if (item?.role === "user") roles.isMyCafeteriaUser = true;
      if (item?.role === "admin") roles.isMyCafeteriaAdmin = true;
    } else if (item?.product === "MyTime") {
      if (item?.role === "user") roles.isMyTimeUser = true;
      if (item?.role === "examiner") roles.isMyTimeExaminer = true;
      if (item?.role === "admin") roles.isMyTimeAdmin = true;
    } else if (item?.product === "MyDocuments") {
      if (item?.role === "uploader" || item?.role === "viewer")
        roles.isMyDocumentsOperator = true;
    } else if (item?.product === "MyTimesheet") {
      if (item?.role === "user") roles.isMyTimesheetUser = true;
      if (item?.role === "examiner") roles.isMyTimesheetExaminer = true;
      if (item?.role === "viewer") roles.isMyTimesheetViewer = true;
      if (item?.role === "admin") roles.isMyTimesheetAdmin = true;
    }
  });

  return (
    <OcPageTransition>
      <Box>
        <Box
          height="80px"
          style={{ backgroundColor: "#cc0033" }}
          display="flex"
          flexDirection="row"
          alignItems="center"
          paddingLeft="14px"
        >
          <Box style={{ color: "white", fontSize: "24px" }}>
            {t("MY_HR_USER_GUIDES")}
          </Box>
        </Box>
        <Box padding={isMobile ? "16px 0px" : "16px"}>
          <Box width={isMobile ? "auto" : "520px"}>
            <OcCard label={t("OC_DOWNLOADS")} loading={false}>
              <>
                <Box>
                  <OcFileViewerAndDownloaderBox
                    label={t("MY_HR_USER_GUIDE")}
                    href="/manual/OrgwareConnect_MyHR_felhasznaloi_kezikonyv.pdf"
                    modul="guides"
                  />
                  <Box height="16px" />
                </Box>
                {roles.isMyNewsUser && (
                  <Box id="mynews-user">
                    <OcFileViewerAndDownloaderBox
                      label={t("MY_NEWS_USER_GUIDE")}
                      href="/manual/OrgwareConnect_MyNews_felhasznaloi_kezikonyv.pdf"
                      modul="guides"
                    />
                    <Box height="16px" />
                  </Box>
                )}
                {roles.isMyNewsEditor && (
                  <Box id="mynews-editor">
                    <OcFileViewerAndDownloaderBox
                      label={t("MY_NEWS_EDITOR_GUIDE")}
                      href="/manual/OrgwareConnect_MyNews_szerkesztoi_kezikonyv.pdf"
                      modul="guides"
                    />
                    <Box height="16px" />
                  </Box>
                )}
                {roles.isMyNewsAdmin && (
                  <Box id="mynews-admin">
                    <OcFileViewerAndDownloaderBox
                      label={t("MY_NEWS_ADMIN_GUIDE")}
                      href="/manual/OrgwareConnect_MyNews_adminisztratori_kezikonyv.pdf"
                      modul="guides"
                    />
                    <Box height="16px" />
                  </Box>
                )}
                {roles.isMyHrAdmin && (
                  <Box id="my-hr-user-guides-admin">
                    <OcFileViewerAndDownloaderBox
                      label={t("MY_HR_ADMIN_GUIDE")}
                      href="/manual/OrgwareConnect_MyHR_adminisztrator_kezikonyv.pdf"
                      modul="guides"
                    />
                    <Box height="16px" />
                  </Box>
                )}
                {roles.isMyHrExaminer && (
                  <Box id="myhr-examiner">
                    <OcFileViewerAndDownloaderBox
                      label={t("MY_HR_EXAMINER_USER_GUIDE")}
                      href="/manual/OrgwareConnect_MyHR_elbiralo_kezikonyv.pdf"
                      modul="guides"
                    />
                    <Box height="16px" />
                  </Box>
                )}
                {roles.isMyLeaveUser && (
                  <Box id="my-hr-user-guides-leave-user">
                    <OcFileViewerAndDownloaderBox
                      label={t("MY_LEAVE_USER_GUIDE")}
                      href="/manual/OrgwareConnect_MyLeave_felhasznaloi_kezikonyv.pdf"
                      modul="guides"
                    />
                    <Box height="16px" />
                  </Box>
                )}
                {roles.isMyLeaveAdmin && (
                  <Box id="my-hr-user-guides-leave-admin">
                    <OcFileViewerAndDownloaderBox
                      label={t("MY_LEAVE_ADMIN_GUIDE")}
                      href="/manual/OrgwareConnect_MyLeave_adminisztrator_kezikonyv.pdf"
                      modul="guides"
                    />
                    <Box height="16px" />
                  </Box>
                )}
                {roles.isMyLeaveExaminer && (
                  <Box id="my-hr-user-leave-examiner">
                    <OcFileViewerAndDownloaderBox
                      label={t("MY_LEAVE_EXAMINER_GUIDE")}
                      href="/manual/OrgwareConnect_MyLeave_elbiralo_kezikonyv.pdf"
                      modul="guides"
                    />
                    <Box height="16px" />
                  </Box>
                )}
                {roles.isMyLeaveViewer && (
                  <Box id="my-hr-user-leave-viewer">
                    <OcFileViewerAndDownloaderBox
                      label={t("MY_LEAVE_VIEWER_GUIDE")}
                      href="/manual/OrgwareConnect_MyLeave_megtekinto_kezikonyv.pdf"
                      modul="guides"
                    />
                    <Box height="16px" />
                  </Box>
                )}
                {roles.isMyLeaveAssigner && (
                  <Box id="mydocuments-viewer">
                    <OcFileViewerAndDownloaderBox
                      label={t("MY_LEAVE_ASSIGNER_GUIDE")}
                      href="/manual/OrgwareConnect_MyLeave_kiiro_kezikonyv.pdf"
                      modul="guides"
                    />
                    <Box height="16px" />
                  </Box>
                )}
                {roles.isMyCafeteriaAdmin && (
                  <Box id="my-cafeteria-admin">
                    <OcFileViewerAndDownloaderBox
                      label={t("MY_CAFETERIA_ADMIN_GUIDE")}
                      href="/manual/OrgwareConnect_MyCafeteria_adminisztrator_kezikonyv.pdf"
                      modul="guides"
                    />
                    <Box height="16px" />
                  </Box>
                )}
                {roles.isMyCafeteriaUser && (
                  <Box id="my-cafeteria-user">
                    <OcFileViewerAndDownloaderBox
                      label={t("MY_CAFETERIA_USER_GUIDE")}
                      href="/manual/OrgwareConnect_MyCafeteria_felhasznaloi_kezikonyv.pdf"
                      modul="guides"
                    />
                    <Box height="16px" />
                  </Box>
                )}
                {roles.isMyTimeUser && (
                  <Box id="mytime-user">
                    <OcFileViewerAndDownloaderBox
                      label={t("MY_TIME_USER_GUIDE")}
                      href="/manual/OrgwareConnect_MyTime_felhasznaloi_kezikonyv.pdf"
                      modul="guides"
                    />
                    <Box height="16px" />
                  </Box>
                )}
                {roles.isMyTimeExaminer && (
                  <Box id="mytime-user">
                    <OcFileViewerAndDownloaderBox
                      label={t("MY_TIME_EXAMINER_GUIDE")}
                      href="/manual/OrgwareConnect_MyTime_elbiraloi_kezikonyv.pdf"
                      modul="guides"
                    />
                    <Box height="16px" />
                  </Box>
                )}
                {roles.isMyTimeAdmin && (
                  <Box id="mytime-user">
                    <OcFileViewerAndDownloaderBox
                      label={t("MY_TIME_ADMIN_GUIDE")}
                      href="/manual/OrgwareConnect_MyTime_adminisztratori_kezikonyv.pdf"
                      modul="guides"
                    />
                    <Box height="16px" />
                  </Box>
                )}
                {myDocumentsEnabled && (
                  <Box id="mydocuments-uploader">
                    <OcFileViewerAndDownloaderBox
                      label={t("MY_DOCUMENTS_USER_GUIDE")}
                      href="/manual/OrgwareConnect_MyDocuments_felhasznaloi_kezikonyv.pdf"
                      modul="guides"
                    />
                    <Box height="16px" />
                  </Box>
                )}
                {roles.isMyDocumentsOperator && (
                  <Box id="mydocuments-viewer">
                    <OcFileViewerAndDownloaderBox
                      label={t("MY_DOCUMENTS_OPERATOR_GUIDE")}
                      href="/manual/OrgwareConnect_MyDocuments_kezeloi_kezikonyv.pdf"
                      modul="guides"
                    />
                    <Box height="16px" />
                  </Box>
                )}
                {roles.isMyTimesheetUser && (
                  <Box id="mytimesheet-user">
                    <OcFileViewerAndDownloaderBox
                      label={t("MY_TIMESHEET_USER_GUIDE")}
                      href="/manual/OrgwareConnect_MyTimesheet_felhasznaloi_kezikonyv.pdf"
                      modul="guides"
                    />
                    <Box height="16px" />
                  </Box>
                )}
                {roles.isMyTimesheetExaminer && (
                  <Box id="mytimesheet-examiner">
                    <OcFileViewerAndDownloaderBox
                      label={t("MY_TIMESHEET_EXAMINER_GUIDE")}
                      href="/manual/OrgwareConnect_MyTimesheet_elbiraloi_kezikonyv.pdf"
                      modul="guides"
                    />
                    <Box height="16px" />
                  </Box>
                )}
                {roles.isMyTimesheetViewer && (
                  <Box id="mytimesheet-viewer">
                    <OcFileViewerAndDownloaderBox
                      label={t("MY_TIMESHEET_VIEWER_GUIDE")}
                      href="/manual/OrgwareConnect_MyTimesheet_megtekintoi_kezikonyv.pdf"
                      modul="guides"
                    />
                    <Box height="16px" />
                  </Box>
                )}
                {roles.isMyTimesheetAdmin && (
                  <Box id="mytimesheet-admin">
                    <OcFileViewerAndDownloaderBox
                      label={t("MY_TIMESHEET_ADMIN_GUIDE")}
                      href="/manual/OrgwareConnect_MyTimesheet_adminisztratori_kezikonyv.pdf"
                      modul="guides"
                    />
                    <Box height="16px" />
                  </Box>
                )}
              </>
            </OcCard>
          </Box>
        </Box>
      </Box>
    </OcPageTransition>
  );
};

export default MyHRUserGuidesPage;
